import { z } from "zod";

/**
 * Currency as an ISO 4217 code. v1 is single-currency (USD); modelled as a
 * literal so adding currencies later is a deliberate, type-checked change.
 */
export const currencySchema = z.literal("USD");
export type Currency = z.infer<typeof currencySchema>;

export const DEFAULT_CURRENCY: Currency = "USD";

/**
 * A monetary amount in integer minor units (cents). Prices are never floats —
 * dollars↔cents conversion happens only at the UI edge.
 */
export const priceCentsSchema = z
  .number()
  .int("price must be a whole number of cents")
  .nonnegative("price cannot be negative")
  .max(1_000_000_000, "price is unreasonably large"); // $10,000,000 ceiling guards typos

/** Format integer minor units as a localized currency string (1999 -> "$19.99"). */
export function formatMoney(cents: number, currency: Currency = DEFAULT_CURRENCY): string {
  return new Intl.NumberFormat("en-US", { style: "currency", currency }).format(cents / 100);
}
